import { Flex } from '../../../GlobalComponents/Flex';
import { CartItemProps } from '../../types';
import { Product } from '../Product';

export type ItemsProps = {
	items: CartItemProps[];
};

export const Products: React.FC<ItemsProps> = ({ items }) => {
	return (
		<Flex $flexDirection="column" $rowGap="16px">
			{items.map(item => (
				<Product
					productId={item.product.id}
					name={item.product.name}
					key={item.id}
					{...item}
				></Product>
			))}
		</Flex>
	);
};
